import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import AutoComplete from '../AutoComplete'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectNumeroGara = () => {
  const availableNumeriGara = useSelector(
    state => state.selection.availableNumeriGara,
  )
  const selectedNumeroGara = useSelector(
    state => state.selection.selectedNumeroGara,
  )

  const { setSelectedNumeroGara } = useSelectionSet()

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <AutoComplete
        id='available-numeriGara'
        label='Numero gara'
        value={selectedNumeroGara}
        options={availableNumeriGara?.map(a => a.numeroGara)}
        onChange={op =>
          setSelectedNumeroGara(
            availableNumeriGara?.find(a => a.numeroGara === op),
          )
        }
      />
    </Grid>
  )
}

export default SelectNumeroGara
